import React, { Fragment } from 'react';
import "./index.css";
import "./assets/css/index.css";
import SocketWrapper from './SocketWrapper';
import SSEWrapper from './SSEWrapper';
class Inbox extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount = async () => {

    };

    render() {
        let socketType = process.env.REACT_APP_SOCKET_TYPE;
        if (socketType === "A") {
            return (
                <SocketWrapper />
            )
        }
        return (
            <SSEWrapper />
        )
    }

}

export default Inbox;
